import React from 'react';
import { 
  Box, 
  Checkbox,
  FormControlLabel,
  Button,
  Typography 
} from '@mui/material';

const TermsAndSubmit = ({ checked, onCheckChange, onSubmit, disabled }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
        mt: 4,
        mb: 2
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={onCheckChange}
            sx={{
              color: '#00B26C',
              '&.Mui-checked': {
                color: '#00B26C',
              },
            }}
          />
        }
        label={
          <Typography sx={{ color: '#012F47' }}>
            Compreendo e concordo com os{' '}
            <Typography
              component="span"
              sx={{
                color: '#00B26C',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
            >
              Termos de uso
            </Typography>
          </Typography>
        }
      />
      
      <Button
        variant="contained"
        disabled={!checked || disabled}
        onClick={onSubmit}
        sx={{
          bgcolor: '#00B26C',
          '&:hover': {
            bgcolor: '#00965B',
          },
          px: 4,
          py: 1.5,
          borderRadius: 2,
          textTransform: 'none',
          fontSize: '1rem'
        }}
      >
        Prosseguir para o pagamento
      </Button>
    </Box>
  );
};

export default TermsAndSubmit;
